import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VMenu,
    {
      attrs: { "offset-y": "", left: "", transition: "slide-y-transition" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                VBadge,
                {
                  key: _vm.keyNotifications,
                  attrs: {
                    bordered: "",
                    content: _vm.newNotifications,
                    value: _vm.newNotifications,
                    overlap: "",
                    "offset-x": "22",
                    "offset-y": "22",
                  },
                },
                [
                  _c(
                    VBtn,
                    _vm._g({ attrs: { icon: "" } }, on),
                    [_c(VIcon, [_vm._v("mdi-bell-outline")])],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        VCard,
        [
          _c(
            VList,
            { attrs: { "two-line": "", dense: "", "max-width": "400" } },
            [
              _c(VSubheader, { staticClass: "pa-2 font-weight-bold" }, [
                _vm._v("Notifications"),
              ]),
              _vm.notificaciones_usuarios.length > 0
                ? _c(
                    VListItemGroup,
                    {
                      key: _vm.keyNotifications,
                      attrs: { "active-class": "gray--text", multiple: "" },
                      model: {
                        value: _vm.notificationsUnread,
                        callback: function ($$v) {
                          _vm.notificationsUnread = $$v
                        },
                        expression: "notificationsUnread",
                      },
                    },
                    [
                      _vm._l(
                        _vm.notificaciones_usuarios,
                        function (item, index) {
                          return [
                            _c(
                              "div",
                              {
                                key: item.document_id,
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickNotification(item)
                                  },
                                },
                              },
                              [
                                index > 0 && index < _vm.items.length
                                  ? _c(VDivider, { attrs: { inset: "" } })
                                  : _vm._e(),
                                _c(VListItem, {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var active = ref.active
                                          return [
                                            _c(
                                              VListItemAvatar,
                                              {
                                                attrs: {
                                                  color: _vm.notificationRead(
                                                    item
                                                  )
                                                    ? "#B1B3B9"
                                                    : item.color,
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { color: "white" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.icon
                                                          ? item.icon
                                                          : "mdi-email-outline"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VListItemContent,
                                              [
                                                _c(
                                                  _vm.notificationRead(item)
                                                    ? "VListItemSubtitle"
                                                    : "VListItemTitle",
                                                  {
                                                    tag: "component",
                                                    staticClass: "text-wrap",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        item[_vm.$i18n.locale]
                                                          .title
                                                      ),
                                                    },
                                                  }
                                                ),
                                                _c(VListItemSubtitle, {
                                                  staticClass:
                                                    "caption text-wrap",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      item[_vm.$i18n.locale]
                                                        .description
                                                    ),
                                                  },
                                                }),
                                                _c("small", {
                                                  staticClass: "mt-1",
                                                  class: _vm.notificationRead(
                                                    item
                                                  )
                                                    ? "grey--text"
                                                    : "secondary--text",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.getFromNowLocale(
                                                        item.created
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  )
                : _c(
                    VListItem,
                    [
                      _c(
                        VListItem,
                        [
                          _c(
                            VListItemAvatar,
                            { attrs: { size: "32", color: "primary" } },
                            [
                              _c(VIcon, { attrs: { dark: "", small: "" } }, [
                                _vm._v("icon-decline"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            VListItemContent,
                            [
                              _c(VListItemTitle, {
                                staticClass: "text-wrap",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.translate(
                                      "frases.no_notifications_title"
                                    )
                                  ),
                                },
                              }),
                              _c(VListItemSubtitle, {
                                staticClass: "caption text-wrap",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.translate("frases.no_notifications")
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-center py-2" },
            [
              _c(
                VBtn,
                {
                  attrs: { small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/userSettings/MyNotifications")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btns.see_all")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }